import Vue from 'vue';

const parseValue = function parseValue(binding) {
    let {value, modifiers} = binding;

    return modifiers.space
        ? ` ${value}`
        : value;
};

Vue.directive('append', {
    inserted: function (element, binding) {
        if (!binding.value) {
            return;
        }

        const value = parseValue(binding);

        element.insertAdjacentText('afterend', value);
        element.appendedTextNode = element.nextSibling;
    },

    unbind: function (element, binding) {
        if (!binding.value) {
            return;
        }

        const value = parseValue(binding);
        const node = element.appendedTextNode;

        if (node && node.nodeType === node.TEXT_NODE && node.data === value) {
            node.remove();
        }
    },
});
